import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import { authApi } from "../features/api/authApi";
import { courseApi } from "../features/api/courseApi";
import { pageApi } from "../features/api/pageApi";
import { postApi } from "../features/api/postApi"; 
import { newsFlashApi } from "../features/api/newsFlashApi";
import { supportApi } from "@/features/api/supportApi";
import { leadApi } from "@/features/api/leadsApi"; 
import { invoiceApi } from "@/features/api/invoiceApi";
import {paymentApi} from "@/features/api/paymentApi"; 
import {partnersApi} from "@/features/api/partnersApi";
import { subscriptionApi } from '@/features/api/subscriptionAPi';
import { contactApi } from "@/features/api/contactApi";
import { profileApi } from "@/features/api/profileApi";
import { mockTestApi } from "@/features/api/mockTestApi";



export const appStore = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      courseApi.middleware,
      pageApi.middleware,
      postApi.middleware,
      newsFlashApi.middleware,
      supportApi.middleware,
      leadApi.middleware,
      invoiceApi.middleware,
      paymentApi.middleware,
      partnersApi.middleware,
      subscriptionApi.middleware,
      contactApi.middleware,
      profileApi.middleware,
      mockTestApi.middleware,

    ),
});

// Initialize app (e.g., load user if token exists)
const initializeApp = async () => {
  try {
    await appStore.dispatch(
      authApi.endpoints.loadUser.initiate(undefined, { forceRefetch: true })
    );
  } catch (error) {
    console.error("Failed to initialize app:", error);
  }
};

initializeApp();
